import { useEffect, useState } from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import styles from '../../../../RenewNonEmployeeAccess.module.scss';
import { getAppsByUser } from '../../../../_api';
import { DataTable } from '../../../../../../../../../components/UI/MDC/DataTable/DataTable';
import Spinner from '../../../../../../../../../components/UI/Spinner/Spinner';

const ReviewApps = ({ staffMember, index, formik }) => {
	const [isLoading, setIsLoading] = useState(false);
	//if staffMember.apps is null or empty, get applications via api call and set the staffMember's application
	useEffect(() => {
		setIsLoading(true);
		if (
			staffMember.fiId &&
			(!staffMember.applications || staffMember.applications.length === 0)
		) {
			getAppsByUser(staffMember.fiId).then(response => {
				let formikStaffMember =
					formik.values.staffMembersForReview[index];
				formikStaffMember.applications = response.data.payload;
				//update formik state with user applications
				let updatedFormikStaffMembers = [
					...formik.values.staffMembersForReview,
				];
				updatedFormikStaffMembers.splice(index, 1, formikStaffMember);
				formik.setFieldValue('staffMembersForReview', [
					...updatedFormikStaffMembers,
				]);
				setIsLoading(false);
			});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const appTable = {
		headers: [
			{
				Value: 'Name',
				props: { sort: null, onSortChange: null },
			},
			{
				Value: 'User Name',
				props: { sort: null, onSortChange: null },
			},
			{
				Value: 'Role',
				props: { sort: null, onSortChange: null },
			},
		],
		rows: staffMember.applications?.map((app, index) => {
			return {
				Cells: {
					Name: {
						Value: app.name,
						Validation: {
							Key: 'true',
							Value: null,
							memberToValidateKey: null,
						},
					},
					'User Name': {
						Value: app.username,
						Validation: {
							Key: 'true',
							Value: null,
							memberToValidateKey: null,
						},
					},
					Role: {
						Value: (
							<p className={styles.cell_max_width}>{app.role}</p>
						),
						Validation: {
							Key: 'true',
							Value: null,
							memberToValidateKey: null,
						},
					},
					Key: app.id.toString(),
				},
			};
		}),
	};

	return (
		<>
			<div className={styles.margin_top_small}>
				<Accordion className={styles.accordion}>
					<AccordionSummary
						className={styles.accordion_summary_secondary}
						expandIcon={
							<ArrowDownwardIcon
								className={styles.accordion_summary_secondary}
							/>
						}
						aria-controls={'StaffMember-content-' + index}
						id={'StaffMember-header-' + index}
					>
						<Typography>Apps</Typography>
					</AccordionSummary>
					<AccordionDetails className={styles.accordion_details}>
						{isLoading ? (
							<Spinner />
						) : (
							<>
								{staffMember.applications &&
								staffMember.applications.length > 0 ? (
									<>
										<DataTable
											rows={appTable.rows}
											headers={appTable.headers}
										/>
									</>
								) : (
									<p>no applications found for this user</p>
								)}
							</>
						)}
					</AccordionDetails>
				</Accordion>
			</div>
		</>
	);
};

export default ReviewApps;
